'use client';

import { useTranslations } from 'next-intl';

import { Button } from '~/components/ui/Button';
import { routes } from '~/config/routes';

export default function SignUpError({ error }: { error: Error }) {
  const t = useTranslations('SignUpError');

  if (error.message !== 'Invite code invalid or expired') {
    throw error;
  }

  return (
    <>
      <div className="flex h-full flex-col justify-center gap-3">
        <h1 className="text-2xl font-bold">{t('title')}</h1>
        <p>{t('invalidCodeDescription')}</p>
        <p>{t('noInviteDescription')}</p>
      </div>
      <div className="mt-8 flex">
        <Button variant="primary" asChild>
          <a href={routes.authSignup()}>{t('backToSignUp')}</a>
        </Button>
      </div>
    </>
  );
}
